<template>
  <div class="shop-top-info-wrapper-box">
    <components
      :is="comName"
      :serviceList="serviceList"
      :isStoreFont="isStoreFont"
      @changeMoreInfoStatus="showMore"
    />
    <MoreDetailBox
      :show="showMoreDetail"
      :type="showMoreDetailType"
      @close="changeMoreInfoStatus(false)"
    />
  </div>
</template>

<script>
import TopInfoH5 from './indexV2H5.vue';
import TopInfoPC from './indexV2PC.vue';
import MoreDetailBox from './moreDetailBox.vue';

import { mapState } from 'vuex';
import defaultBg from '../../assets/images/default_bg.png';

export default {
  name: 'ShopTopInfo',
  components: {
    TopInfoH5,
    TopInfoPC,
    MoreDetailBox,
  },
  props: {
    isStoreFont: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      doBusiness: true,
      showMoreDetail: false,
      showMoreDetailType: 'info',
      actTips: [],
      onlyTag: false,

      defaultBg,
    };
  },
  computed: {
    ...mapState({
      isH5: ({ common }) => common.isH5,
      shopInfo: ({ store }) => store.shopInfo,
      shopHeader: ({ store }) => store.shopHeader,
    }),
    comName() {
      return this.isH5 ? 'TopInfoH5' : 'TopInfoPC';
    },
    serviceList() {
      let { fulfillmentV3 = [] } = this.shopHeader;
      let fulfillment = this.parseDeliveryFreeInfo(fulfillmentV3);
      if (+this.shopInfo.cShopStatus !== 1) {
        fulfillment = [];
      }
      return [...fulfillment];
    },
  },
  mounted() {},
  methods: {
    goBack() {
      this.$router.back();
    },
    showMore(type = 'info') {
      if (type === 'coupon') {
        // 目前没有券的数据actTipsDetails，暂时屏蔽券弹窗
        return;
      }
      this.showMoreDetailType = type;
      this.changeMoreInfoStatus(true);
    },
    changeMoreInfoStatus(status) {
      this.showMoreDetail = status;
    },
    // 通用数据初处理
    parseDeliveryFreeInfo(list) {
      // 解析配送费字段 第一个展示价格，第二个有动调展示动调，第三个 展示券icon，第四个展示说明文案；中间缺失了依次递进
      let arr = [];
      list.forEach((item, index) => {
        if (item.titleInfo) {
          let {
            titleInfo,
            contentInfo,
            couponInfo,
            oriPriceInfo,
            surgeInfo,
            thresholdInfo,
          } = item;
          let contentList = [];
          let obj = {
            ...titleInfo,
            type: index === 1 ? 'fee' : '',
            title: titleInfo?.content,
            contentListFE: contentList,
          };
          if (couponInfo?.icon) {
            contentList.push({
              class: `coupon-info margin-r-4`,
              content: couponInfo?.icon,
              type: 'IconPart',
            });
          }
          if (contentInfo?.content) {
            contentList.push({
              class: 'content-info font-bold margin-r-4',
              content: contentInfo?.content,
            });
          }
          if (oriPriceInfo?.content) {
            contentList.push({
              class: 'ori-price-info',
              content: oriPriceInfo?.content,
            });
          }
          if (surgeInfo && surgeInfo.icon) {
            contentList.push({
              type: 'IconPart',
              class: `margin-r-4 surge-info`,
              content: surgeInfo.icon,
            });
          }
          if (thresholdInfo?.content) {
            contentList.push({
              class: `threshold-info`,
              content: thresholdInfo?.content,
            });
          }
          arr.push(obj);
        } else {
          arr.push(item);
        }
      });
      return arr;
    },
  },
};
</script>

<style lang="scss" scoped></style>
